import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./ProjectListCard.css";
import { useNavigate } from "react-router-dom";

const ProjectListCard = ({
  slug,
  category,
  featured,
  title,
  description,
  technologies = [],
  features = [],
}) => {
  const [showAllTech, setShowAllTech] = useState(false);
  const [showAllFeatures, setShowAllFeatures] = useState(false);

  const visibleTech = showAllTech ? technologies : technologies.slice(0, 6);
  const visibleFeatures = showAllFeatures ? features : features.slice(0, 3);
  const navigate = useNavigate();

  return (
    <Card className="project_card">
      <div className="card_head">
        {featured && <p className="project_featured">Featured</p>}
        <p className="project_category">{category}</p>
      </div>

      <h3 className="project_title">{title}</h3>
      <p className="project_description">{description}</p>

      <div className="project_tech">
        {visibleTech.map((tech, index) => (
          <span key={index}>{tech}</span>
        ))}

        {technologies.length > 6 && !showAllTech && (
          <span className="more_link" onClick={() => setShowAllTech(true)}>
            +{technologies.length - 6} more
          </span>
        )}
      </div>

      <div className="project_features">
        <h6>Key Features:</h6>
        <ul>
          {visibleFeatures.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>

        {features.length > 3 && (
          <span
            className="more_link"
            onClick={() => setShowAllFeatures(!showAllFeatures)}
          >
            {showAllFeatures
              ? "Show Less"
              : `+${features.length - 3} more features`}
          </span>
        )}
      </div>

      <Link to={`/portfolio/${slug}`} className="project_btn">
        View Details
      </Link>
    </Card>
  );
};

export default ProjectListCard;
